import { makeStyles } from "@material-ui/core/styles";
import { Grid } from "@material-ui/core";
import { FieldSetBox } from "../fieldSetBox";
import { ReportField } from "./reportField";
import { observer } from "mobx-react";
import { formatCurrencyField, formatDateField, getStringOrDefault } from "../../utils/utils";

const useStyles = makeStyles(() => ({
  currentPropertyBox: {
    height: "114px",
  },
}));

interface CurrentPropertyStatusBoxProps {
  propertyStatusInformation: any;
}

export const CurrentPropertyStatusBox = observer(({ propertyStatusInformation }: CurrentPropertyStatusBoxProps) => {

  const classes = useStyles();

  return (<FieldSetBox title="Current Property Status">
    <Grid container className={classes.currentPropertyBox}>
      <Grid item xs={4}>
        <ReportField
          label="Current Property Status"
          value={getStringOrDefault(propertyStatusInformation.propertyStatus)}
        />
      </Grid>
      <Grid item xs={4}>
        <ReportField label="Original List Date" value={formatDateField(propertyStatusInformation.originalListDate)} />
      </Grid>
      <Grid item xs={4}>
        <ReportField
          label="Original List Price"
          value={formatCurrencyField(propertyStatusInformation.originalListPrice)}
          removeRightBorder
        />
      </Grid>
      <Grid item xs={4}>
        <ReportField label="Sale Type" value={getStringOrDefault(propertyStatusInformation.saleType)} />
      </Grid>
      <Grid item xs={4}>
        <ReportField label="Last Sale Date" value={formatDateField(propertyStatusInformation.lastSaleDate)} />
      </Grid>
      <Grid item xs={4}>
        <ReportField
          label="Last Sale Price"
          value={formatCurrencyField(propertyStatusInformation.lastSalePrice)}
          removeRightBorder
        />
      </Grid>
    </Grid>
  </FieldSetBox>);
});